// Dependency-free helpers for the "HERE MIGRATION VALIDATION" (mode 4) search
// filter and its polyline-building counterpart. Kept free of JSX/redux/window
// so they're directly unit testable.

// UI label uses the user's wording ("Need Validation"); the value sent to the
// backend is the real RouteMaster.hereMigrationStatus enum value
// ('validation-required'), not the label text.
//
// 'false-negative', 'validated', and 'false-positive' are never set by the
// migration script itself -- they're only ever set by a human editing the
// MIGRATION column directly in the grid (see MasterRoutes.js):
//   'false-negative' -- flagged 'validation-required' by the script, but a
//     human confirmed the route was already fine (the flag was wrong).
//   'validated' -- flagged 'validation-required' by the script, the issue
//     was real, and a human has since fixed/confirmed the route is correct.
//   'false-positive' -- marked 'success' by the script, but a human found
//     the route is actually wrong.
export const HERE_MIGRATION_STATUS_OPTIONS = [
  { value: 'validation-required', label: 'Need Validation' },
  { value: 'success', label: 'Success' },
  { value: 'false-negative', label: 'False Negative' },
  { value: 'validated', label: 'Validated' },
  { value: 'false-positive', label: 'False Positive' },
];

export function buildHereMigrationFilter(status) {
  return { mode: 4, hereMigrationStatus: status };
}

// Mirrors the per-item polyline logic that used to live inline in
// routemasterSaga.js's setPolylines. Builds the "new" (current) polyline from
// row.routes, and, only when present, a second "old" (backup) polyline from
// row.bk_routes for visual old/new comparison.
//
// decodePath: window.google.maps.geometry.encoding.decodePath, injected so
// this module has no `window` dependency of its own.
export function buildRoutePolylines(row, decodePath) {
  const polylines = [];
  if (!row) return polylines;

  let id = 0;
  if (row.id) id = row.id;
  else id = row.Vehicle;

  // Capture the routes object into a local before doing the equivalent of
  // today's `item = item.routes` reassignment, so sibling fields on `row`
  // (like `bk_routes`) stay reachable afterwards.
  const routesObj = row.routes ? row.routes : row;

  const newPath = decodePath(
    decodeURIComponent(routesObj.MergeRoute ? routesObj.MergeRoute : routesObj.Route)
  );

  polylines.push({
    id: id,
    path: newPath,
    info: {
      name: routesObj.name,
      description: routesObj.detail,
      logisticsPoint: routesObj.logisticsPoint,
    },
    isGroup: false,
    editable: false,
  });

  if (row.bk_routes) {
    const bkRoutesObj = row.bk_routes;
    const oldPath = decodePath(
      decodeURIComponent(bkRoutesObj.MergeRoute ? bkRoutesObj.MergeRoute : bkRoutesObj.Route)
    );

    polylines.push({
      id: id + '-old',
      path: oldPath,
      info: {
        name: routesObj.name,
        description: routesObj.detail,
        logisticsPoint: routesObj.logisticsPoint,
      },
      isGroup: false,
      editable: false,
      isBackup: true,
      clickable: false,
    });
  }

  return polylines;
}
